import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select/src/tom-select'

export default class extends Controller {
  static targets = ['providerSelect', 'accountSelect']

  declare readonly providerSelectTarget: HTMLSelectElement
  declare readonly accountSelectTargets: TomSelect[]

  connect (): void {
    this.updateAccountSelects()
  }

  providerChanged (): void {
    this.updateAccountSelects()
  }

  private updateAccountSelects (): void {
    const selectedProvider = this.providerSelectTarget.value

    this.accountSelectTargets.forEach(select => {
      const selectProvider = select.dataset.providerType
      const shouldShow = selectProvider === selectedProvider

      this.toggleElement(select, shouldShow)

      select.disabled = !shouldShow
      select.required = shouldShow
      select.tomselect?.clear()
    })
  }

  private toggleElement (element: TomSelect, show: boolean): void {
    const wrapper = element.closest('.space-y-1\\.5')

    if (wrapper != null) {
      wrapper.classList.toggle('hidden', !show)
    } else {
      element.classList.toggle('hidden', !show)
    }
  }
}
